export default __webpack_public_path__ + "static/media/androidPad.4a462384.webp";